// Lon/lat <-> Web Mercator (EPSG:3857), the same sums as OpenLayers' fromLonLat and
// toLonLat for the default projection. For code the landing page loads (place search,
// user location), so it doesn't pull OpenLayers' projection code into the main bundle.
const R = 6378137;
const HALF_SIZE = Math.PI * R;

export const fromLonLat = ([lon, lat]) => {
    const x = R * Math.PI * lon / 180;
    let y = R * Math.log(Math.tan(Math.PI * (+lat + 90) / 360));
    if (y > HALF_SIZE) y = HALF_SIZE;
    else if (y < -HALF_SIZE) y = -HALF_SIZE;
    return [x, y];
};

export const toLonLat = ([x, y]) => {
    let lon = 180 * x / HALF_SIZE;
    const lat = 360 * Math.atan(Math.exp(y / R)) / Math.PI - 90;
    if (lon < -180 || lon > 180) lon = ((lon + 180) % 360 + 360) % 360 - 180;
    return [lon, lat];
};
